import React, { useState } from 'react'
import ProfileSettings from './_components/ProfileSettings'
import SystemSettings from './_components/SystemSettings'
import BlockedUsersList from './_components/BlockedUsersList'
import NotificationSettings from './_components/NotificationSettings'

type SettingsTab = 'profile' | 'blocked' | 'notification' | 'system'

export default function SettingsModule(): React.JSX.Element {
  const [activeTab, setActiveTab] = useState<SettingsTab>('profile')

  return (
    <div className="h-full bg-gray-50 flex flex-col">
      {/* 顶部标题栏 */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-gray-900">设置</h1>
        </div>
      </div>

      {/* 标签页导航 */}
      <div className="bg-white border-b border-gray-200 px-6">
        <nav className="flex space-x-8">
          <button
            onClick={() => setActiveTab('profile')}
            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'profile'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
          >
            个人资料
          </button>

          {/* <button
            onClick={() => setActiveTab('blocked')}
            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'blocked'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
          >
            拉黑用户列表
          </button> */}

          {/* <button
            onClick={() => setActiveTab('notification')}
            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'notification'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
          >
            通知设置
          </button> */}

          {/* <button
            onClick={() => setActiveTab('system')}
            className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === 'system'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
          >
            系统设置
          </button> */}
        </nav>
      </div>

      {/* 内容区域 */}
      <div className="flex-1 overflow-auto">
        {activeTab === 'profile' && <ProfileSettings />}
        {activeTab === 'blocked' && <BlockedUsersList />}
        {activeTab === 'notification' && <NotificationSettings />}
        {activeTab === 'system' && <SystemSettings />}
      </div>
    </div>
  )
}
